(() => {
  const initializedAttribute = 'data-christmas-countdown-initialized';
  const snowInitializedAttribute = 'data-snow-initialized';

  function initializeCountdown(countdown) {
    if (countdown.hasAttribute(initializedAttribute)) return;

    const target = Date.parse(countdown.dataset.target || '');
    if (!Number.isFinite(target)) {
      countdown.hidden = true;
      return;
    }

    countdown.setAttribute(initializedAttribute, 'true');

    const fields = {
      days: countdown.querySelector('[data-countdown-days]'),
      hours: countdown.querySelector('[data-countdown-hours]'),
      minutes: countdown.querySelector('[data-countdown-minutes]'),
    };

    function update() {
      const remaining = Math.max(0, target - Date.now());
      const totalMinutes = Math.floor(remaining / 60000);

      const values = {
        days: String(Math.floor(totalMinutes / 1440)).padStart(2, '0'),
        hours: String(Math.floor((totalMinutes % 1440) / 60)).padStart(2, '0'),
        minutes: String(totalMinutes % 60).padStart(2, '0'),
      };
      Object.keys(values).forEach((key) => {
        if (fields[key].textContent !== values[key]) fields[key].textContent = values[key];
      });

      if (remaining > 0) window.setTimeout(update, Math.min(remaining, remaining % 60000 + 1));
    }

    update();
  }

  function initialize(root = document) {
    root.querySelectorAll('[data-christmas-countdown]').forEach(initializeCountdown);
    initializeEditorialCarousels(root);
    initializeSnowfall();
  }

  function initializeEditorialCarousels(root = document) {
    root.querySelectorAll('[data-editorial-carousel]').forEach((carousel) => {
      if (carousel.hasAttribute('data-editorial-carousel-initialized')) return;

      const track = carousel.querySelector('[data-editorial-track]');
      const previous = carousel.querySelector('[data-editorial-prev]');
      const next = carousel.querySelector('[data-editorial-next]');
      const cards = Array.from(carousel.querySelectorAll('[data-editorial-slide]'));
      if (!track || !previous || !next || !cards.length) return;

      carousel.setAttribute('data-editorial-carousel-initialized', 'true');
      let centerIndex = cards.findIndex((card) => /first christmas/i.test(card.textContent));
      if (centerIndex < 0) centerIndex = 0;
      let busy = false;
      let startX = null;
      let startY = null;
      let suppressClick = false;

      function offsetFor(index) {
        let offset = index - centerIndex;
        if (offset > cards.length / 2) offset -= cards.length;
        if (offset < -cards.length / 2) offset += cards.length;
        return offset;
      }

      function render() {
        cards.forEach((card, index) => {
          const offset = offsetFor(index);
          card.removeAttribute('data-editorial-pos');
          card.setAttribute('aria-hidden', offset === 0 ? 'false' : 'true');
          card.tabIndex = offset === 0 ? 0 : -1;
          if (Math.abs(offset) <= 2) card.setAttribute('data-editorial-pos', String(offset));
        });
        track.setAttribute('data-editorial-ready', 'true');
      }

      function shift(direction) {
        if (!direction || busy || cards.length < 2) return;
        const moveFocus = cards[centerIndex].contains(document.activeElement);
        busy = true;
        centerIndex = (centerIndex + direction + cards.length) % cards.length;
        render();
        if (moveFocus) cards[centerIndex].focus({ preventScroll: true });
        window.setTimeout(() => { busy = false; }, 610);
      }

      cards.forEach((card, index) => {
        card.addEventListener('click', (event) => {
          const offset = offsetFor(index);
          if (offset === 0) return;
          event.preventDefault();
          event.stopPropagation();
          shift(offset);
        });
      });

      track.addEventListener('click', (event) => {
        if (!suppressClick || event.detail === 0) return;
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      }, true);

      previous.addEventListener('click', (event) => {
        event.preventDefault();
        shift(-1);
      });

      next.addEventListener('click', (event) => {
        event.preventDefault();
        shift(1);
      });

      track.addEventListener('pointerdown', (event) => {
        startX = event.clientX;
        startY = event.clientY;
      });

      track.addEventListener('pointerup', (event) => {
        if (startX === null || startY === null) return;
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        startX = null;
        startY = null;
        if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
          event.preventDefault();
          suppressClick = true;
          window.setTimeout(() => { suppressClick = false; }, 0);
          shift(deltaX < 0 ? 1 : -1);
        }
      });

      track.addEventListener('pointercancel', () => {
        startX = null;
        startY = null;
      });

      carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          shift(-1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          shift(1);
        }
      });

      render();
    });
  }

  function randomBetween(min, max) {
    return Math.random() * (max - min) + min;
  }

  function initializeSnowfall() {
    const snowfall = document.querySelector('#christmas-snowfall');
    if (!snowfall || snowfall.getAttribute(snowInitializedAttribute) === 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    snowfall.setAttribute(snowInitializedAttribute, 'true');
    const count = window.innerWidth <= 749 ? 40 : 85;
    const fragment = document.createDocumentFragment();

    for (let index = 0; index < count; index += 1) {
      const flake = document.createElement('span');
      flake.className = 'snowflake';
      flake.style.left = `${randomBetween(0, 100)}vw`;
      flake.style.setProperty('--size', `${randomBetween(1, 4).toFixed(1)}px`);
      flake.style.setProperty('--opacity', randomBetween(0.45, 0.95).toFixed(2));
      flake.style.setProperty('--blur', `${randomBetween(0, 0.7).toFixed(1)}px`);
      flake.style.setProperty('--fall-duration', `${randomBetween(11, 22).toFixed(2)}s`);
      flake.style.setProperty('--sway-duration', `${randomBetween(3, 7).toFixed(2)}s`);
      flake.style.setProperty('--delay', `${randomBetween(-22, 0).toFixed(2)}s`);
      flake.style.setProperty('--sway-delay', `${randomBetween(-7, 0).toFixed(2)}s`);
      flake.style.setProperty('--drift', `${randomBetween(-45, 45).toFixed(0)}px`);
      flake.style.setProperty('--rotation', `${randomBetween(-120, 120).toFixed(0)}deg`);
      fragment.appendChild(flake);
    }

    snowfall.appendChild(fragment);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
